import React from "react";
import { motion } from "framer-motion";
import { experiences } from "./constants";
import "../styles/experience.css";

function Experience() {
  return (
    <motion.div
      className="experience__main page"
      variants={{
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="page-heading">Experience</h1>
      <p className="page-subtitle">
        3+ years across production engineering, platform, and AI infrastructure
      </p>

      <div className="timeline">
        {experiences.map((exp, idx) => {
          const isPromotion =
            idx > 0 && experiences[idx - 1].company === exp.company;
          return (
            <div className="timeline__item" key={exp.id}>
              <div className="timeline__marker" />
              <div className="timeline__card">
                <div className="timeline__header">
                  <h2>
                    {isPromotion ? (
                      <span className="timeline__company-cont">
                        {exp.company}
                      </span>
                    ) : (
                      exp.company
                    )}
                    {idx === 0 && (
                      <span className="timeline__badge">Current</span>
                    )}
                    {isPromotion && (
                      <span className="timeline__badge timeline__badge--promo">
                        Promoted
                      </span>
                    )}
                  </h2>
                  <span className="timeline__period">{exp.period}</span>
                </div>
                <p className="timeline__role">{exp.role}</p>
                <p className="timeline__location">{exp.location}</p>
                <ul className="timeline__highlights">
                  {exp.highlights.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}

export default Experience;
